// extracted by mini-css-extract-plugin
export default {"root":"WAxFD0DxXzBLf7mody9s","attribute":"iigOj39sZ1EUqyEDu5tv"};